import { render } from "./PKGame.vue?vue&type=template&id=49f57210&scoped=true"
import script from "./PKGame.vue?vue&type=script&lang=js"
export * from "./PKGame.vue?vue&type=script&lang=js"

import "./PKGame.vue?vue&type=style&index=0&id=49f57210&lang=css"
import "./PKGame.vue?vue&type=style&index=1&id=49f57210&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f57210"]])

export default __exports__